module.exports = __webpack_public_path__ + "media/images/apple-touch-icon-8044eb2a97bbe8429fec19e2e0bafa95.png";